import * as Schema from "effect/Schema";
import { EnvironmentId, ThreadId, TrimmedNonEmptyString } from "./baseSchemas.ts";

const Time = TrimmedNonEmptyString.check(Schema.isMaxLength(64));
export const PocketConversationCursor = Schema.Struct({
  lastActivityAt: Time,
  createdAt: Time,
  threadId: ThreadId.check(Schema.isMaxLength(256)),
}).annotate({ parseOptions: { onExcessProperty: "error" } });
export type PocketConversationCursor = typeof PocketConversationCursor.Type;
export const PocketConversationPageRequest = Schema.Struct({
  worldKey: TrimmedNonEmptyString.check(Schema.isMaxLength(256)),
  cursor: Schema.optionalKey(PocketConversationCursor),
}).annotate({ parseOptions: { onExcessProperty: "error" } });
export const PocketConversationPage = Schema.Struct({
  worldKey: Schema.String,
  actorId: Schema.String,
  environmentId: EnvironmentId,
  worldSessionId: Schema.String,
  threads: Schema.Array(
    Schema.Struct({
      threadId: ThreadId,
      title: Schema.String.check(Schema.isMaxLength(1024)),
      createdAt: Time,
      lastActivityAt: Time,
    }),
  ).check(Schema.isMaxLength(20)),
  nextCursor: Schema.NullOr(PocketConversationCursor),
});
export type PocketConversationPage = typeof PocketConversationPage.Type;
